module.exports = __webpack_public_path__ + "img/Multiview - Blue - Selected.ac7e17b3.png";